import React from 'react';
import ValidateImport from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/ValidateImport";
import ProcessImport from "v4/pages/admin/Import/components/ImportSteps/components/ProcessImport/ProcessImport";

export default function ValidateAndProcessImport({isProcessing}) {
    return (
        <div className="validate-and-process-import">
            {isProcessing && <ProcessImport/>}
            <ValidateImport isProcessing={isProcessing}/>
        </div>
    )
}
